
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualizzazioni',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Immettere un numero',
	'maxValuePlaceholder': 'Immettere un numero',
	'customRangeErrorMessage': 'Il valore deve essere numerico',
	'propFillColor': 'Colore riempimento',
	'propBorderColor': 'Colore bordo',
	'propColorPalette': 'Tavolozza colori corrente',
	'propColorPaletteChangeLabel': 'Modifica tavolozza colori',
	'propNewColorPaletteLabel': 'Crea una tavolozza  colori personalizzata',
	'propNewHeatPaletteLabel': 'Crea una tavolozza heat personalizzata',
	'propDonutRadius': 'Raggio grafico ad anello',
	'showTitleLabel': 'Mostra titolo',
	'titleTypeLabel': 'Tipo di titolo',
	'smartTitleLabel': 'Titolo Smart',
	'customTitleLabel': 'Titolo personalizzato',
	'noTitleLabel': 'Nessun titolo',
	'propHeatScalePalette': 'Tavolozza di calore corrente',
	'propHeatPaletteChangeLabel': 'Modifica tavolozza di calore',
	'propMaintainAxisScales': 'Conserva scala asse',
	'propLineAndSymbolColor': 'Colore linea e simbolo',
	'propLineAndSymbolPalette': 'Tavolozza colori per linea e simbolo',
	'propElementColor': 'Colore elemento',
	'propColumnColor': 'Colore colonna',
	'propColumnPalette': 'Tavolozza colori colonna',
	'propColumnHeatPalette': 'Tavolozza calore calore',
	'propBarColor': 'Colore barra',
	'propGoalColor': 'Colore di destinazione',
	'propToColor': 'Colore A',
	'propFromColor': 'Colore Da',
	'propNumberValidationErrorMessageId': 'Immettere un numero.',
	'fontSizeAuto': 'Automatico',
	'propAutoBinCount': 'Numero di gruppi',
	'propAutoBinToggle': 'Raggruppamento automatico',
	'tabName_general': 'Generale',
	'tabName_visDetails': 'Dettagli',
	'tabName_animation': 'Animazione',
	'tabName_mediaDetails': 'Dettagli supporti',
	'tabName_webDetails': 'Dettagli pagina Web',
	'tabName_imageDetails': 'Dettagli immagine',
	'tabName_visualization': 'Visualizzazione',
	'tabName_text': 'Testo',
	'sectionName_colorsAndThemes': 'Colore e temi',
	'sectionName_appearance': 'Aspetto',
	'sectionName_general': 'Generale',
	'sectionName_colorPalette': 'Colore',
	'sectionName_axis': 'Asse',
	'sectionName_axis_label': 'Asse',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Grafico',
	'sectionName_regionLayer': 'Livello delle regioni',
	'sectionName_pointLayer': 'Livello dei punti',
	'sectionName_latLongLayer': 'Livello latitudine/longitudine',
	'sectionName_pathLayer': 'Livello percorso',
	'propTransparencyDescription': 'Rendere l\'oggetto più o meno trasparente Immettere un valore compreso tra 0 e 100',
	'smart_annotation_unauthorized': 'Annotazioni: accesso non autorizzato',
	'smart_annotation_method': 'Annotazioni: metodo non consentito',
	'smart_annotation_media': 'Annotazioni: tipo di supporto non consentito',
	'smart_annotation_input': 'Annotazioni: input non valido',
	'smart_annotation_internal': 'Annotazioni: errore di sistema interno',
	'smart_annotation_generic_error': 'Annotazioni: errore del servizio',
	'smart_annotation_dialog_title': 'Insight',
	'smart_errors': 'Errori di annotazione:',
	'smart_warnings': 'Avvertenze annotazione:',
	'smart_annotation_insight_icon_title': 'Insight',
	'smart_annotations_toggle_on': 'Attiva insight',
	'smart_annotations_toggle_off': 'Disattiva insight',
	'smart_annotation_insight_unavailable': 'Insight attualmente non disponibili',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Non sono disponibili insight quando viene applicato un filtro % superiore o inferiore.',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Non sono disponibili previsioni quando viene applicato un filtro % superiore o inferiore.',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Gli insight non sono disponibili quando viene applicato un filtro superiore o inferiore ed esiste più di una colonna nel campo.',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Le previsioni non sono disponibili quando viene applicato un filtro superiore o inferiore ed esiste più di una colonna nel campo.',
	'forecast_title': 'Previsione',
	'forecast_toggle_on': 'Attiva previsione',
	'forecast_toggle_off': 'Disattiva previsione',
	'statDetailsPerspectiveTitle': 'Analisi',
	'emptyStatDetailsPanel': 'Non è disponibile nessuna ulteriore analisi per la visualizzazione corrente.',
	'predict_errors': 'Errori di analisi',
	'predict_warnings': 'Avvertenze di analisi',
	'fpd_invalid_data_source': 'Questa origine dati non ha un modulo smarts associato',
	'fpd_network_issue': 'Si è verificato un problema durante l\'esecuzione dell\'analisi su questa origine dati',
	'fpd_data_source_category': 'Modulo Smarts mancante',
	'fpd_response_errors': 'Errori driver consigliato',
	'fpd_response_warnings': 'Avvertenze driver consigliato',
	'catalyst_service_bad_request': 'Richiesta non valida',
	'catalyst_service_unkown_Id': 'Individuato ID richiesta sconosciuto',
	'catalyst_service_internal_server_error': 'Errore server interno',
	'catalyst_service_generic_error': 'Errore server Catalyst',
	'catalyst_service_error': 'Questo servizio non è attualmente disponibile',
	'propLegendPosition': 'Posizione legenda',
	'propLeft': 'Sinistra',
	'propRight': 'Destra',
	'propTop': 'In alto',
	'propBottom': 'In basso',
	'propNone': 'Nessuno',
	'propLegendDisplay': 'Visualizza legenda',
	'targetThicknessPlaceHolder': '%{min} a %{max}',
	'targetThicknessErrorMsg': 'Immettere un numero intero compreso tra %{min} e %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Driver (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'selezionati)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Reimposta valori predefiniti',
	'possibelKeyDriver_AddNewDrivers': 'Aggiungi ulteriori driver',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Ricerca per aggiungere altri driver',
	'possibleKeyDrivers_MaxPossibleReached': 'Annullare la selezione di alcuni driver per aggiungerne o selezionarne altri',
	'possibleKeyDrivers_Recommended': 'Consigliato',
	'visRecommendedTypes': 'Tipi di visualizzazione consigliati',
	'visRecommender_smartsfailure': 'le indicazioni di visualizzazione non sono attualmente disponibili',
	'visMore': 'Altro...',
	'visMoreTooltip': 'Altre visualizzazioni',
	'visOtherTypes': 'Altri tipi di visualizzazione',
	'visChange': 'Cambia visualizzazione',
	'automaticTypeCaption': 'Automatico',
	'propVisType': 'Tipi di visualizzazione',
	'dlg_loading': 'Caricamento in corso...',
	'snippetListChartCaption': 'Elenco frammenti',
	'convoClusterChartCaption': 'Cluster conversazione',
	'areaChartCaption': 'Area',
	'barChartCaption': 'Barra',
	'columnChartCaption': 'Colonna',
	'stackedbarChartCaption': 'Barra in pila',
	'stackedcolumnChartCaption': 'Colonna in pila',
	'bubbleChartCaption': 'Bolla',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analisi driver',
	'scatterChartCaption': 'Dispersione',
	'lineChartCaption': 'Linea',
	'pointChartCaption': 'Punto',
	'heatChartCaption': 'Mappa calore',
	'bulletChartCaption': 'Punto elenco',
	'waterfallChartCaption': 'Cascata',
	'pieChartCaption': 'Torta',
	'mapChartCaption': 'Mappa',
	'radialBarChartCaption': 'Radiale',
	'compositeChartCaption': 'Linea e colonna',
	'wordCloudChartCaption': 'Word cloud',
	'networkChartCaption': 'Rete',
	'relationshipNetworkChartCaption': 'Rete di relazione',
	'treemapChartCaption': 'Mappa struttura ad albero',
	'packedBubbleChartCaption': 'Diagramma a bolle',
	'hierarcicalPackedBubbleChartCaption': 'Bolla gerarchia',
	'spiralChartCaption': 'Spirale',
	'decisionTreeChartCaption': 'Struttura ad albero delle decisioni',
	'legacyMapChartCaption': 'Mappa esistente',
	'sunburstChartCaption': 'Grafico radiale',
	'visUsageComparison': 'Confronto',
	'visUsageRelationships': 'Relazioni',
	'visUsageTrend': 'Tendenza',
	'visUsagePartsToWhole': 'Parti rispetto all\'intero',
	'visUsageGeospatial': 'Geospaziale',
	'visUsageAdvanced': 'Analisi avanzate',
	'visUsageTablesAndSummary': 'Tabelle e riepilogo',
	'visUsageSocialInsights': 'Informazioni social',
	'visUsageOther': 'Altro',
	'autoBinActionText': 'Raggruppa automatico',
	'filterAutobinActionText': 'Filtra bin',
	'memberCalculationActionText': 'Calcolo membro',
	'toolbarActionCalculation': 'Calcolo',
	'toolbarActionEditCalculation': 'Modifica calcolo',
	'topBottomRankLabel': 'Classifica (%{label})',
	'toolbarDeleteFilterActionText': 'Rimuovi filtro',
	'toolbarActionTopKeyDrivers': 'Mostra driver',
	'toolbarActionCustomGroup': 'Gruppo personalizzato',
	'canNotCreateCustomGroup': 'Impossibile creare questo gruppo personalizzato.',
	'aria_label_datatable': 'Tabella dati',
	'summaryCaption': 'Riepilogo',
	'MeasuresCaption': 'Misure',
	'MeasuresGroupCaption': 'Gruppo di misure (%{count})',
	'ValuesCaption': 'Valori',
	'turnInsightsOn': 'Attiva insights',
	'turnInsightsOff': 'Disattiva insights',
	'decisionRules': 'Regole',
	'decisionTree': 'Diagramma struttura ad albero',
	'decisionSunburst': 'Grafico radiale struttura ad albero',
	'switchToDecisionRules': 'Passa a regole decisione',
	'switchToDecisionTree': 'Passa a struttura decisione',
	'data_group_less_then': 'minore di %{rangeTo}',
	'data_group_to': '%{rangeFrom} a < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} e superiore',
	'nullValueContent': '(nessun valore)',
	'sum': 'Somma',
	'count': 'Conteggio',
	'countdistinct': 'Conteggio distinti',
	'avg': 'Media',
	'min': 'Minimo',
	'max': 'Massimo',
	'automatic': 'Personalizzato',
	'variance': 'Varianza',
	'stddev': 'Deviazione standard',
	'median': 'Mediana',
	'calculated': 'Calcolato',
	'none': 'Nessuno',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'Lo scenario di prompt non è attualmente supportato.',
	'preAggregateLabel': 'Applica i valori di prompt dell\'origine dati',
	'postAggregateLabel': 'Applica i valori di prompt nel report',
	'preAggregateText': 'L\'intervallo utilizza i valori nell\'origine dati, non i valori visualizzati nel dashboard.',
	'defaultAggregation_count': 'Conteggio',
	'defaultAggregation_countdistinct': 'Conteggio distinti',
	'defaultAggregation_max': 'Massimo',
	'defaultAggregation_min': 'Minimo',
	'defaultAggregation_avg': 'Media',
	'defaultAggregation_sum': 'Somma',
	'defaultAggregation_auto': 'Automatico (%{aggregationType})',
	'keydriver_average': 'Media generale',
	'keydriver_up_down': 'I gruppi evidenziati con medie elevate o basse hanno maggiore impatto sull\'obiettivo. I gruppi con medie insolitamente alte o basse hanno l\'impatto maggiore.',
	'keydriver_different': 'I gruppi evidenziati hanno distribuzioni che differiscono significativamente dalla distribuzione generale. Questi gruppi hanno maggiore impatto sull\'obiettivo.',
	'topOperator': 'In alto',
	'bottomOperator': 'In basso',
	'topBottomFact': '%{operator} %{value}%{percent} per %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Elimina conteggio dei primi elementi o degli ultimi elementi',
	'deleteTopBottomPercent': 'Elimina primi elementi o ultimi %',
	'topBottomTitle': 'Solo questo oggetto',
	'deleteTopBottom': 'Elimina conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottom': 'Modifica conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottomCount': 'Modifica conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottomPercent': 'Modifica primi elementi o ultimi %',
	'ariaDeleteTopBottomCountLabel': 'Premere il tasto ELIMINA per eliminare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaDeleteTopBottomPercentLabel': 'Premere il tasto ELIMINA per eliminare i primi elementi o gli ultimi',
	'ariaEditTopBottomCountLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaEditTopBottomPercentLabel': 'Premere il tasto INVIO per modificare i primi elementi o gli ultimi %.',
	'ariaDeleteDrillStateLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'drillUpStateTitle': 'Drill up',
	'drillDownStateTitle': 'Drill down',
	'ariaEditTopBottomLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaDeleteTopBottomLabel': 'Premere il tasto ELIMINA per eliminare il conteggio dei primi elementi o degli ultimi elementi.',
	'allKeyDriversLabel': 'Auto (tutti i driver)',
	'filter_drag_and_drop_single_dock': 'Trascinare e rilasciare i dati in questo punto per filtrare.',
	'filter_drag_and_drop_all_tabs': 'Trascinare e rilasciare i dati in questo punto per filtrare tutte le schede.',
	'filter_drag_and_drop_current_tab': 'Trascinare e rilasciare i dati in questo punto per filtrare questa scheda.',
	'filter_empty_consume_mode': 'Non sono stati applicati filtri.',
	'filterClearAllItems': 'Annulla tutti i filtri',
	'filterDeleteAllItems': 'Elimina tutti i filtri',
	'filterDockChevronLeft': 'Scorrere i dati',
	'filterDockChevronRight': 'Scorrere i dati',
	'filterIconLabel_Single': 'Filtri',
	'filterIconLabel_Global': 'Tutte le schede',
	'filterIconLabel_Tab': 'Questa scheda',
	'filterIconTooltip_Single': 'Filtri',
	'filterIconTooltip_Global': 'Filtri per tutte le schede',
	'filterIconTooltip_Tab': 'Filtri per questa scheda',
	'filterDropZoneTooltip_Single': 'Zona di rilascio filtro',
	'filterDropZoneTooltip_Global': 'Zona di rilascio filtro per tutte le schede',
	'filterDropZoneTooltip_Tab': 'Zona di rilascio filtro per questa scheda',
	'filterOverflowMenu': 'Altro',
	'expand': 'Espandi',
	'collapse': 'Comprimi',
	'filterDockItemNameAriaLabel': 'Premere Invio per avviare la finestra di dialogo del filtro e definire il filtro.',
	'filterItemCanvasMove': 'Aggiungi ad area di lavoro',
	'filterItemDelete': 'Elimina filtro',
	'filterInvertRange': 'tutto tranne: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Non dopo %{from}',
	'filter_date_after': 'Dopo %{from}',
	'filter_date_before_except': 'Non prima %{to}',
	'filter_date_before': 'Prima %{to}',
	'filter_date_between_except': 'Non tra %{from}-%{to}',
	'filter_date_between': 'Tra %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Tutte',
	'filterExcept': 'tranne %{values}',
	'filterDockToolbarButtonLabel': 'Dock filtro',
	'navigateTitle': 'Passa a',
	'current_nav_group': 'Il gruppo di navigazione corrente è  %{navigation_group_name}',
	'next': 'Avanti',
	'previous': 'Indietro',
	'multiselectMsg': '%{count} selezionati',
	'errMsgFilterItemMissingTitle': 'Impossibile caricare i valori filtro %{itemName} perché questi valori non sono disponibili con questo dataset.',
	'errMsgFilterItemGenericTitle': 'Impossibile caricare \'t i valori filtro',
	'textFilterItemsNotFound': 'Nessun elemento disponibile.',
	'nullValueLabel': '(vuoto)',
	'filterConditionLabel': 'Condizione filtro',
	'filter_includesAll': 'Include tutto',
	'filter_allMembersOfSet': 'Tutti i membri della serie',
	'modelFilter': 'Filtro',
	'filtersTitle': 'Proprietà filtro',
	'search': 'Ricerca',
	'clearTextFilterValue': 'Annulla',
	'invertFilterSelection': 'Inverti',
	'modellingLoading': 'Caricamento in corso...',
	'searchAll': 'Trova tutte le colonne',
	'toolbarActionPossibleKeyDrivers': 'Modifica ambito',
	'toolbarActionPossibleKeyDriversSubTitle': 'Trascinare da sinistra gli elementi che devono essere considerati nel grafico di analisi driver',
	'toolbarActionSort': 'Ordina',
	'toolbarActionSortAscending': 'Ordine crescente',
	'toolbarActionSortDescending': 'Ordine decrescente',
	'toolbarActionSortAuto': 'Automatico (%{sortOrder})',
	'toolbarActionSortCustom': 'Personalizzato',
	'toolbarActionFormat': 'Formato',
	'toolbarActionFormatAbbreviation': 'Abbrevia',
	'toolbarActionFormatNone': 'Automatico',
	'toolbarActionFilter': 'Filtro',
	'toolbarActionTopBottom': 'Primi elementi o ultimi elementi',
	'toolbarActionRmvShape': 'Rimuovi forma',
	'toolbarActionToggleShapeDrop': 'Forma infografico',
	'toolbarActionToggleShapeDropTitle': 'Crea un infografico',
	'toolbarActionToggleShapeDropText': 'Trascinare la forma in questo campo per creare un infografico.',
	'toolbarActionAggregationType': 'Riepiloga',
	'toolbarDeleteActionText': 'Rimuovi colonna',
	'toolbarTextActionText': 'Formatta testo',
	'toolbarActionFilterLocalKeepSelected': 'Conserva',
	'toolbarActionFilterLocalExcludeSelected': 'Escludi',
	'toolbarActionFilterAllKeepSelected': 'Filtro',
	'toolbarActionSimpleCalculation': 'Calcoli semplici',
	'toolbarActionDrillBack': 'Indietro',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionNavigate': 'Naviga',
	'toolbarActionCreateFilterGroup': 'Crea nuova connessione',
	'toolbarActionDisconnectFilterGroup': 'Interrompi tutti i collegamenti',
	'toolbarActionLinkFilterGroup': 'Aggiungi ad una connessione esistente',
	'toolbarActionLassoSelect': 'Seleziona strumento',
	'toolbarActionRefreshDeveloperWidget': 'Aggiorna',
	'textFontFamilySubClassHairline': 'Sottile',
	'textFontFamilySubClassThin': 'Sottile',
	'textFontFamilySubClassThinItalic': 'Corsivo sottile',
	'textFontFamilySubClassExtraLight': 'Chiarissimo',
	'textFontFamilySubClassExtraLightItalic': 'Corsivo chiarissimo',
	'textFontFamilySubClassLight': 'Chiaro',
	'textFontFamilySubClassLightItalic': 'Corsivo chiaro',
	'textFontFamilySubClassRegular': 'Regolare',
	'textFontFamilySubClassRegularItalic': 'Corsivo regolare',
	'textFontFamilySubClassItalic': 'Corsivo',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Corsivo medio',
	'textFontFamilySubClassHeavy': 'Pesante',
	'textFontFamilySubClassHeavyItalic': 'Corsivo pesante',
	'textFontFamilySubClassDemiBold': 'Mezzo grassetto',
	'textFontFamilySubClassDemiBoldItalic': 'Corsivo mezzo grassetto',
	'textFontFamilySubClassBold': 'Grassetto',
	'textFontFamilySubClassBoldItalic': 'Corsivo grassetto',
	'textFontFamilySubClassExtraBold': 'Grassetto scuro',
	'textFontFamilySubClassExtraBoldItalic': 'Corsivo scuro',
	'textFontFamilySubClassBlack': 'Nero',
	'textFontFamilySubClassBlackItalic': 'Corsivo nero',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'crescente',
	'dlg_descending': 'decrescente',
	'dlg_custom': 'personalizzato',
	'dlg_none': 'nessuno',
	'dlg_hierarchy': 'gerarchia',
	'dlg_namedSet': 'insieme denominato',
	'dlg_rank': 'classifica',
	'remove_slider_handle': 'Rimuovi handle',
	'visualizationLabel': 'Visualizzazione',
	'chartLabel': 'Grafico %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Premere F12 per navigare all\'interno del widget',
	'f10KeyDescription': 'Premere F10 per avviare la vista attiva del widget',
	'playButtonLabel': 'Riproduci',
	'dataPlayerValueListLabel': 'Valori Data player',
	'localFilterTitle': 'Solo questo oggetto',
	'globalFilterTitle': 'Tutti gli oggetti',
	'deleteFilter': 'Elimina filtro',
	'editFilter': 'Modifica filtro',
	'ariaEditFilterLabel': 'Premere il tasto INVIO per modificare il filtro.',
	'ariaDeleteFilterLabel': 'Premere il tasto ELIMINA per eliminare il filtro.',
	'measureFilterBetween': 'Compreso tra %{lowerBound} e %{upperBound}',
	'measureFilterNotBetween': 'Non compreso tra  %{lowerBound} e %{upperBound}',
	'dimFilterIn': 'Include: %{in}',
	'dimFilterNotIn': 'Escluso: %{out}',
	'gtFilter': 'Dopo %{lowerBound}',
	'ltFilter': 'Prima %{upperBound}',
	'ariaEditPrompt': 'Premere il tasto INVIO per modificare il valore di prompt',
	'dataPointFilterTitle': 'Punti dati',
	'dataPointFilterIncludeSummary': 'Incluso %{valueCount} punti dati',
	'dataPointFilterExcludeSummary': 'Esclusi %{valueCount} punti dati',
	'widgetFiltersLabel': 'Filtri del widget',
	'coachMarkTitleSpiralTarget': 'Modifica ambito',
	'coachMarkContentSpiralTarget': 'Da qui è possibile accedere e modificare la selezione del driver per la propria destinazione.',
	'srILVTreeLabel': 'Elenco',
	'geomapUnrecognizedLocations': 'Ubicazioni non riconosciute',
	'geomapAmbiguousLocations': 'Regioni ambigue:',
	'visualizationNotifications': 'Notifiche di visualizzazione:',
	'dataNotifications': 'Notifiche di dati:',
	'autobinSuggestion': 'Attiva raggruppamento automatico',
	'LIVE_empty_visualization_hint_title': 'Creazione della visualizzazione',
	'LIVE_empty_visualization_hint_description': 'Trascinare i dati in questo punto o nei campi.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica un campo obbligatorio',
	'LIVE_slots_drag_and_drop_description': 'Trascinare e rilasciare i dati nei campi sopra riportati per creare e filtrare la visualizzazione.',
	'dwErrorLoadingAvailableVisualizations': 'Impossibile caricare le definizioni di visualizzazione disponibili',
	'moreDataIndicator': 'I dati sono stati ridotti a %{threshold} elementi. Applicare un filtro per mostrarne di meno.',
	'nonCtxTopBottomInvalid': 'Definizione della regola inferiore o superiore senza contesto non è supportato per le tabelle incrociate. È stata rimossa da questa vista della tabella incrociata.  Definire nuovamente la regola per una o più categorie nel contesto della %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Impossibile caricare l\'oggetto perché in esso manca una definizione di visualizzazione.',
	'dwErrorLoadingVisualizationListNotFound': 'Impossibile caricare la visualizzazione.',
	'dwErrorRunningQuery': 'Impossibile recuperare i dati dal dataset %{datasetName}.',
	'dwErrorGeoData': 'Si stanno verificando problemi durante la visualizzazione dei dati geografici nella mappa. Scegliere un altro tipo di visualizzazione.',
	'dwPromptSignonCancelWarning': 'I dati di questa visualizzazione non sono disponibili. Fornire le credenziali corrette.',
	'dwErrorMissingDataset': 'Impossibile caricare la visualizzazione perché il relativo dataset associato \'%{datasetName}\' non è disponibile.',
	'dwErrorRenderingVisualization': 'Impossibile caricare questa visualizzazione.',
	'dwErrorVisualizationTooSmall': 'La visualizzazione è troppo piccola per visualizzare i dati che contiene. Ingrandire la visualizzazione o limitare i dati che contiene.',
	'errorSourceNotFound': 'Impossibile caricare la visualizzazione perché l\'origine associata \'%{sourceName}\' non è disponibile',
	'errorActionNotSupported': 'Questa azione non è supportata per l\'origine dati  \'%{sourceName}\'.',
	'errorMeasureNotSupportedOnMultiEdges': 'La visualizzazione ha misure su più bordi il che non è più supportato. Posizionare le misure solo su un bordo.',
	'errorExceedAllowableValue': 'Il numero stimato di celle supera il valore ammissibile di 100000. Applicare filtri per gli insiemi progettati per ridurre il numero di celle. ',
	'propScaleLabel': 'Quantità di icone',
	'propScaleDescription': 'Selezionare le quantità di icone',
	'propScaleFew': 'Basso',
	'propScaleDefault': 'Impostazione predefinita',
	'propScaleMany': 'Alto',
	'lastRefresh': 'Ultimo aggiornamento: %{timeInterval}',
	'widgetTimer': 'Timer del widget',
	'datasetItemsUnavailable': 'Alcuni elementi del dataset utilizzati in questa visualizzazione non sono disponibili.',
	'datasetItemUnavailable': 'Questo elemento del dataset non è disponibile',
	'retry': 'Ritenta',
	'widgetConditionalFormatLabel': 'Attiva/disattiva i controlli di formato condizionali',
	'widgetConditionalFormatTitle': 'Modifica colore di formattazione condizionale',
	'conditionalPalettePickerLabel': 'Distribuzione di valori %{title}',
	'HistogramYAxisTitle': 'Conteggio',
	'crosstabName': 'Tabella incrociata',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/D',
	'summaryLabel': '%{label} con valore %{value}',
	'infographicLabel': '%{label} con valore %{value}',
	'warning': 'Avvertenza',
	'swapRowsAndColumns': 'Inverti righe e colonne',
	'hideSummariesLabel': 'Nascondi riepiloghi',
	'showSummariesLabel': 'Mostra riepiloghi',
	'hideRowColumn': 'Nascondi',
	'showAllRowColumn': 'Mostra tutto',
	'dataAssetPropertiesLabel': 'Proprietà di visualizzazione',
	'evAdd': 'Aggiungi una colonna',
	'evCollapse': 'Comprimi',
	'evColumns': 'Colonne',
	'evLocalFilters': 'Filtri locali',
	'evExpand': 'Espandi',
	'evFilterTooltip': 'Filtro',
	'missingColumn': 'Manca: %{columnLabel}',
	'missingFiltering': 'Filtri mancanti sulle colonne:',
	'missingDataItem': 'L\'elemento dati di riferimento \'%{dataItemId}\' non è stato trovato nel widget.',
	'heatByLabel': 'Calore per',
	'toolbarChangeVisualization': 'Cambia visualizzazione',
	'modellingRelatedTablesNoneFound': 'Nessuna tabella correlata trovata',
	'processing': 'Elaborazione in corso...',
	'errorCellWarning': 'Impossibile calcolare alcuni valori di riepilogo.',
	'aggregateTypeToggler': 'Mostra tipo di aggregazione',
	'maxColumnsExceeded': 'Numero massimo di colonne superato. %{columns} rilasciate.',
	'unboundColumns': 'Impossibile utilizzare le seguenti colonne: %{columns}.',
	'unboundColumn': 'Impossibile utilizzare le seguenti colonne: %{columns}.',
	'recommendRequestFailed': 'Richiesta di consiglio non riuscita. Contattare l\'amministratore.',
	'visualizationDoesNotSupportOLAP': 'Impossibile creare questa visualizzazione che si basa su un\'origine dati OLAP. Utilizzare un\'altra origine dati supportata.',
	'showDataBehindVizLabel': 'Mostra dati',
	'showDataBehindVizNotSupportedLabel': 'L\'opzione Mostra dati non è supportata per questo tipo di visualizzazione',
	'exploreData': 'Esplora ...',
	'newExplore': 'Nuova esplorazione',
	'thumbnails_error_fetching': 'Errore durante il richiamo delle anteprime',
	'loadedThumbnailImage': 'Caricata immagine di anteprima del tipo di visualizzazione %{visType}',
	'autobinAxisLabel': 'gruppi',
	'recommended_visualizations': 'Visualizzazioni consigliate',
	'all_visualizations': 'Tutte le visualizzazioni',
	'edit': 'Modifica',
	'selectTargetDialogTitle': 'Seleziona una destinazione drill-through',
	'noTargetInCM': 'Impossibile trovare la destinazione del drill-through',
	'errorDrillDefinition': 'Qualcosa non era corretto durante l\'aggiunta o la modifica della definizione drill-through.',
	'errorDrillToTarget': 'Si è verificato un errore durante l\'analisi di \'%{targetName}\'',
	'drillThroughMappingViewLabel': 'Assegna le colonne dal dashboard per i prompt del report di destinazione',
	'drillthroughScopeRadioLabel': 'Applica questa definizione a:',
	'drillthroughScopeRadioOptionVisualization': 'Solo questa visualizzazione',
	'drillthroughScopeRadioOptionConnection': 'Le visualizzazioni nella stessa connessione che utilizzano la stessa origine dati',
	'drillthroughScopeRadioOptionDashboard': 'Qualsiasi visualizzazione su %{perspective} che utilizza la stessa origine dati.',
	'drillThroughParametersColumnTitle': 'Prompt \'%{targetName}\':',
	'drillThroughMetadataColumnTitle': 'Colonne dati \'%{boardName}\':',
	'drillThroughDefinitionNoParameter': 'La destinazione di drill-through non dispone di prompt.',
	'drillThroughDefinitionErrorQueryingReport': 'Correggere il problema con il report di destinazione e quindi ritentare la creazione della definizione drill-through.',
	'drillThroughDefinitionErrorDlgTitle': 'Qualcosa non era corretto',
	'dlg_back': 'Torna indietro',
	'dlg_close': 'Chiudi',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annulla',
	'dlg_apply': 'Applica',
	'drillthrough_unsaveMsg': 'Continua senza salvare \'%{name}\'?',
	'drillthrough_jumpTo': 'Definizione drill-through: %{name}',
	'drillthrough_jumpToLabel': 'Drill through',
	'drillthrough_manage': 'Gestione in corso...',
	'drillthrough_addNewTarget': 'Aggiungi una nuova definizione drill-through',
	'drillthrough_manageJumpPaths': 'Gestisci definizioni drill-through',
	'drillthrough_manageJumpPaths_edit': 'Modifica \'%{name}\'',
	'drillthrough_manageJumpPaths_delete': 'Elimina \'%{name}\'',
	'drillthrough_manageAddAnotherTarget': 'Aggiungi un\'altra definizione drill-through',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Conferma eliminazione',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Si è sicuri di voler eliminare drill-through \'%{name}\'?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Nome drill-through duplicato',
	'drillthrough_definitionMessage': 'Il drill-through \'%{name}\' già esiste. Fornire un differente nome',
	'drillthrough_jumpToTarget_notFound': 'Impossibile trovare la destinazione per il drill-through \'%{name}\'',
	'drillThroughDefinitionNoParameterSubTitle': 'Nessun contesto verrà passato al report di destinazione.',
	'drillthrough_titleLabel': 'Titolo',
	'drillthrough_subTitle': 'Il contesto della visualizzazione nella propria origine viene utilizzato per filtrare la destinazione %{perspective}.',
	'noPrompt': 'Nessun prompt',
	'formatAutoDescription': 'Specifica automaticamente il formato ereditato dall\'origine dati o dalla visualizzazione.',
	'formatDefaultDescription': 'Specifica predefinita del formato ereditato dal sistema',
	'createCustomGroupAction': 'Crea gruppo di dati',
	'removeCustomGroupAction': 'Rimuovi gruppo di dati',
	'editCustomGroupAction': 'Modifica gruppo di dati',
	'renameCustomGroupAction': 'Rinomina gruppo di dati',
	'createCustomGroupErrorToast': 'Impossibile creare un gruppo di dati',
	'removeCustomGroupErrorToast': 'Impossibile rimuovere un gruppo di dati',
	'editCustomGroupErrorToast': 'Impossibile modificare un gruppo di dati',
	'renameCustomGroupErrorToast': 'Impossibile rinominare un gruppo di dati',
	'customGroupLabel': 'Gruppo di dati',
	'ungroupCustomGroupLabel': 'Annulla raggruppamento',
	'renameCustomGroupLabel': 'Rinomina',
	'createCustomGroupLabel': 'Crea',
	'customGroupingLabel': '%{columnLabel} (Gruppo)',
	'createCustomSort': 'Crea ordinamento personalizzato',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Selezionare gli articoli disponibili, quindi riordinarli per creare un ordinamento personalizzato.',
	'availableItems': 'Elementi disponibili',
	'selectAll': '(Seleziona tutto)',
	'customSortOrder': 'Ordinamento personalizzato',
	'selectAvailableItemsDesc': 'Seleziona gli articoli disponibili quindi riordina qui.',
	'moveToTop': 'Sposta in alto',
	'clear': 'Annulla',
	'sortRemainingItemsBy': 'Ordina gli elementi rimanenti per',
	'clearAll': 'Cancella tutto',
	'resetTooltip': 'Tutti gli articoli saranno rimossi dall\'elenco %{customSortOrder}. E il menu a discesa %{sortRemainingItemsBy} tornerà al valore predefinito.',
	'manyItemsWarning': 'La selezione di molti articoli potrebbe influire sul rendimento della tua dashboard.',
	'manyItemsSelected': 'Sono stati selezionati più di %{maxItems} elementi, questo potrebbe influire sul rendimento della dashboard.',
	'somethingWentWrong': 'Qualcosa non era corretto',
	'unableToLoadItems': 'Impossibile caricare gli articoli disponibili.',
	'tryAgain': 'Ritenta',
	'customSortLabel': 'Ordinamento personalizzato',
	'applyError': 'Impossibile applicare %{action}.',
	'searchReturnedNoResults': 'La ricerca non ha prodotto risultati',
	'tryDifferentSearchTerm': 'Si prega di provare un termine di ricerca diverso',
	'extVisSystem': 'Sistema',
	'extVisCustom': 'Personalizzato',
	'customVisTestVisualization': 'Visualizzazione di test',
	'extVisCustomVisPreview': 'anteprima',
	'extVisCustomPreviewWidgets': 'Widget sviluppatori',
	'extVisCustomVVisualization': 'Visualizzazione',
	'extVisCustomVisuals': 'Visualizzazioni personalizzate',
	'noPermissionToManage': 'Non si dispone dell\'autorizzazione per gestire le visualizzazioni personalizzate.',
	'extVisCustomUpdate': 'Aggiorna',
	'extVisCustomDelete': 'Elimina',
	'extVisNoCustomVisuals': 'Nessuna visualizzazione personalizzata',
	'extVisNoCustomVisualsMsg': 'Nell\'organizzazione non sono attualmente presenti visualizzazioni personalizzate',
	'extVisAddCustomVisual': 'Aggiungi una visualizzazione personalizzata',
	'extVisNoCustomVisualsAdminMsg': 'Attualmente non esistono visualizzazioni personalizzate. Aggiungerne una per iniziare',
	'extVisNoSDKConnection': 'Non è stata creata nessuna connessione al file locale',
	'extVisNoSDKPreviewMsg': 'Per eseguire l\'anteprima delle visualizzazioni, stabilire una connessione.',
	'extVisMore': 'Altro',
	'extVisDeleteDialogTitle': 'Elimina visualizzazione personalizzata',
	'extVisDeleteDialogBody': 'Si è sicuri di voler eliminare questa visualizzazione personalizzata? Questa visualizzazione potrebbe essere utilizzata da altri dashboard e report.',
	'extVisDeleteConfirmation': 'La visualizzazione personalizzata è stata eliminata.',
	'extVisDeleteError': 'Impossibile eliminare la visualizzazione personalizzata %{msg}',
	'extVisCloseToast': 'Chiudi ora',
	'extVisAdd': 'La visualizzazione personalizzata è stata aggiunta correttamente.',
	'extVisAddError': 'Impossibile aggiungere la visualizzazione personalizzata. %{msg}',
	'extVisUpdate': 'La visualizzazione personalizzata è stata aggiornata correttamente',
	'extVisUpdateError': 'Impossibile aggiornare la visualizzazione aggiornata %{msg}',
	'extVisAddProgress': 'Importazione di %{name}',
	'extVisUpdateProgress': 'Aggiornamento di %{name}',
	'extPermissionTitle': 'Accesso limitato o visualizzazione personalizzata eliminata',
	'extPermissionBody': 'Impossibile visualizzare  questa visualizzazione personalizzata perché è stata eliminata o ha un accesso limitato.',
	'customVizSaveWarning': 'Impossibile salvare le visualizzazioni personalizzate. Non sono stati importate.',
	'schematicTestCaption': 'Schema test',
	'schematicServiceRequestError': 'Errore servizio schema',
	'extVisPreviewMessage': 'Questa è un\'anteprima. La visualizzazione non è stata ancora aggiunta al prodotto.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Non definito',
	'kpiDefaultTargetLabel': 'Destinazione',
	'kpiNonNumericTarget': 'Il valore di destinazione deve essere un numero.',
	'kpiManualTargetSlotFilled': 'Valore applicato nel campo',
	'kpiAutoValueSize': 'Automatico',
	'kpiUnableDrawSparklineLabel': 'Impossibile disegnare una sparkline',
	'kpiUnableDrawSparklineInfo': 'Una sparkline richiede un minimo di due punti nel tempo. Modificare i dati o regolare i filtri per vedere la sparkline.',
	'conditionalFormattingEnabled': 'Colore condizionale',
	'currentConditionalPalette': 'Tavolozza condizionale corrente',
	'sectionName_range': 'Intervallo impostato',
	'rangeScaleLabel': 'Scala',
	'rangeScalePercentage': 'Percentuale',
	'rangeScaleNumeric': 'Numerico',
	'numberOfSteps': 'Numero di intervalli',
	'conditionalFormattingSelectedStep': 'Intervallo selezionato',
	'conditionalFormattingStartValue': 'Valore iniziale',
	'conditionalFormattingEndValue': 'Valore finale',
	'conditionalFormattingTextColor': 'Colore testo',
	'conditionalFormattingMin': 'Minimo',
	'conditionalFormattingMax': 'Massimo',
	'conditionalFormattingNonNumericValue': 'Il valore deve essere un numero.',
	'conditionalFormattingStepIndexInvalid': 'L\'indice di intervallo non è valido.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'Il valore deve essere compreso tra %{start} e %{end}.',
	'conditionalFormattingValueShouldBeLower': 'Il valore deve essere minore o uguale di %{value}.',
	'conditionalFormattingValueSouldBeHigher': 'Il valore deve essere maggiore o uguale di %{value}.',
	'conditionalFormattingDeleteStep': 'Rimuovi intervallo selezionato',
	'conditionalFormattingRestoreSteps': 'Ripristina intervalli',
	'conditionalFormattingReversePalette': 'Inverti colori',
	'conditionalFormattingShapeIndicator': 'Forma indicatore',
	'conditionalFormattingIconNone': 'Nessuna forma',
	'conditionalFormattingIconArrowUp': 'Freccia su',
	'conditionalFormattingIconArrowRight': 'Freccia destra',
	'conditionalFormattingIconArrowDown': 'Freccia giù',
	'conditionalFormattingIconCaretUp': 'Accento circonflesso su',
	'conditionalFormattingIconDash': 'Trattino',
	'conditionalFormattingIconCaretDown': 'Accento circonflesso giù',
	'conditionalFormattingIconCheckmark': 'Segno di spunta',
	'conditionalFormattingIconWarning': 'Avvertenza',
	'conditionalFormattingIconXSymbol': 'Simbolo X',
	'conditionalFormattingIconCircle': 'Cerchio',
	'conditionalFormattingIconTriangle': 'Triangolo',
	'conditionalFormattingIconDiamond': 'Rombo',
	'conditionalFormattingIconFaceSatisfied': 'Faccia soddisfatta',
	'conditionalFormattingIconFaceNeutral': 'Faccia neutra',
	'conditionalFormattingIconFaceDissatisfied': 'Faccia insoddisfatta',
	'suppression': 'Soppressione',
	'suppressNone': 'Nessuno',
	'suppressRowsAndColumns': 'Righe e colonne',
	'suppressRows': 'Righe',
	'suppressColumns': 'Colonne',
	'enableSuppression': 'Abilita soppressione',
	'disableSuppression': 'Disabilita soppressione',
	'loadVisDefinitionError': 'Impossibile aprire la definizione per la visualizzazione %{id}',
	'emptyVisualization': 'Svuota visualizzazione',
	'expandCollapse': 'Espandi & comprimi',
	'expandBtnLabel': 'Espandi',
	'collapseBtnLabel': 'Comprimi',
	'prop_sizeInputNonNumericValue': 'Il valore deve essere un numero.',
	'prop_sizeValueShouldBeHigher': 'Il valore deve essere maggiore di %{value}.',
	'fontPropLabel': 'Famiglia di caratteri',
	'fontSizePropLabel': 'Dimensione carattere',
	'sectionItemAxisTitle': 'Titolo asse elemento',
	'sectionItemAxisLabel': 'Etichetta asse elemento',
	'sectionValueAxisTitle': 'Titolo asse valore',
	'sectionValueAxisLabel': 'Etichetta asse Valore',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Visualizzazione',
	'ds-missingDataSet': 'Impossibile trovare dataset. Si prega di assicurarsi che il dataset sia creato correttamente.',
	'ds-missingDashboardId': 'Salvare il dashboard prima di creare il dataset.',
	'ds-unsupportedDataSourceType': 'Il tipo di origine dati %{type} non è supportato.'
});
